import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FreshWorksWidgetsService {
    private hideWidgetPaths: string[] = ['editor', 'ad-studio', 'project'];

    constructor() { }

    public hideFreshWorksWidgets() {
        if (window['fcWidget']) {
            window['fcWidget'].hide();
        }

        if (window['FreshworksWidget']) {
            window['FreshworksWidget']('hide');
        }
    }

    public showFreshWorksWidgets() {
        const shouldKeepWidgetHidden = this.hideWidgetPaths.some(path => window.location.pathname.includes(path));

        if(shouldKeepWidgetHidden) {
            this.hideFreshWorksContainer();
            return;
        }

        if (window['fcWidget']) {
            window['fcWidget'].show();
        }
        if (window['FreshworksWidget']) {
            window['FreshworksWidget']('show');
        }

        this.showFreshWorksContainer();
    }

    public showFreshWorksContainer() {
        const freshworksContainer = document.getElementById('freshworks-container');
        freshworksContainer?.classList.add('visible');

        const freshworksWidget = document.getElementById('fc_frame');
        if (freshworksWidget) {
            freshworksWidget.classList.add('visible');
        }
    }

    public hideFreshWorksContainer() {
        const freshworksContainer = document.getElementById('freshworks-container');
        freshworksContainer?.classList.remove('visible');

        const freshworksWidget = document.getElementById('fc_frame');
        if (freshworksWidget) {
            freshworksWidget.classList.remove('visible');
        }
    }
}